import { PopoverTooltip } from '@/components/Tooltip/PopoverTooltip'
import { InfoRounded } from '@mui/icons-material'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

interface SummaryRowProps {
  label: string
  tooltip?: string
  value: React.ReactNode
  color?: string
  bold?: boolean
}

export const SummaryRow: React.FC<SummaryRowProps> = ({ label, value, tooltip, color, bold }) => (
  <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
    <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0, mr: 1 }}>
      {label}
      {tooltip && (
        <PopoverTooltip content={tooltip}>
          <InfoRounded sx={{ fontSize: 12, ml: 0.5, verticalAlign: 'middle' }} />
        </PopoverTooltip>
      )}
    </Typography>
    <Typography variant="body2" fontWeight={bold ? 'bold' : 'medium'} color={color} textAlign="right">
      {value}
    </Typography>
  </Stack>
)

interface SectionHeaderProps {
  title: string
  color?: string
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ title, color }) => (
  <Typography variant="subtitle1" fontWeight="bold" color={color}>
    {title}
  </Typography>
)
